import { useContext } from "react";
import {
  BsInstagram,
  BsLinkedin,
  BsMoonFill,
  BsFillSunFill,
  BsGithub,
} from "react-icons/bs";
import { CursorContext } from "../context/CursorContext";

const Socials = ({ theme, handleThemeSwitch }) => {
  // 🧩 Grab cursor interaction handlers
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  return (
    // 🧩 Only visible on xl screens, triggers custom cursor on hover
    <div
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
      className="hidden xl:flex ml-24"
    >
      <ul className="flex gap-x-4">
        {/* 🧩 Social links open in new tabs */}
        <li>
          <a
            href="https://www.instagram.com/_guruleo_/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsInstagram />
          </a>
        </li>
        <li>
          <a
            href="http://www.linkedIn.com/in/guruprakash-leo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsLinkedin />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/Guru-Leo-Dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsGithub />
          </a>
        </li>

        {/* 🧩 Theme toggle button */}
        <li>
          <button onClick={handleThemeSwitch}>
            {theme === "light" ? <BsMoonFill /> : <BsFillSunFill />}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Socials;
